import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantEmploymentStatusPage = {
  alert: {
    error: 'applicant-employment-status-page.form.alert.error',
  },
  footer: {
    root: 'applicant-employment-status-page.footer.root',
  },
  form: {
    h1: 'applicant-employment-status-page.form.h1',
    h2: 'applicant-employment-status-page.form.h2',
    radioGroupRoot: 'applicant-employment-status-page.form.radio-group-root',
    radioOption1: 'applicant-employment-status-page.form.radio-option-1',
    radioOption2: 'applicant-employment-status-page.form.radio-option-2',
    root: 'applicant-employment-status-page.form.root',
    submitButton: 'applicant-employment-status-page.form.submit-button',
  },
  header: {
    drawerButton: 'applicant-employment-status-page.header.drawer-button',
    previousStepButton:
      'applicant-employment-status-page.header.previous-step-button',
    root: 'applicant-employment-status-page.header.root',
  },
  progress: {
    root: 'applicant-employment-status-page.progress.root',
  },
} as const satisfies PageLocatorMap;
